export const SET_UNIT_VALUE_SELECTION = "SET_UNIT_VALUE_SELECTION";
export const SET_PUMP_FAMILIES_PENDING = "SET_PUMP_FAMILIES_PENDING";
export const SET_PUMP_FAMILIES = "SET_PUMP_FAMILIES";
export const GET_SEARCHDATA_PENDING = "GET_SEARCHDATA_PENDING";
export const SET_SEARCHDATA = "SET_SEARCHDATA";
export const GET_SEARCHDATA_SUCCESS = "GET_SEARCHDATA_SUCCESS";
export const GET_SEARCHDATA_ERROR = "GET_SEARCHDATA_ERROR";
export const SET_PUMP_DATA_LIST_PAGER = "SET_PUMP_DATA_LIST_PAGER";
export const OPEN_PRINT_SELECTION_MODEL = "OPEN_PRINT_SELECTION_MODEL";
export const CLOSE_PRINT_SELECTION_MODEL = "CLOSE_PRINT_SELECTION_MODEL";
export const SET_QEFF_GRAPH_PENDING = "SET_QEFF_GRAPH_PENDING";
export const SET_QEFF_GRAPH = "SET_QEFF_GRAPH";
export const SET_SHAFT_GRAPH_PENDING = "SET_SHAFT_GRAPH_PENDING";
export const SET_FILTER_VALUES = "SET_FILTER_VALUES";
export const SET_PUMP_FAMILY = "SET_PUMP_FAMILY";
export const SET_SHAFT_GRAPH = "SET_SHAFT_GRAPH";
export const SET_SELECTION_CRITERIA = "SET_SELECTION_CRITERIA";
export const SET_PUMPREPORT_PENDING = "SET_PUMPREPORT_PENDING";
export const SET_PUMPREPORT = "SET_PUMPREPORT";
export const SET_CURRENT_FIELD = "SET_CURRENT_FIELD";
export const SET_SI_VALUE_PENDING = "SET_SI_VALUE_PENDING";
export const SET_SIVALUE = "SET_SIVALUE";
export const SET_UNIT_VALUE_PENDING = "SET_UNIT_VALUE_PENDING";
export const SET_UNIT_VALUE_CHANGE = "SET_UNIT_VALUE_CHANGE";
export const SET_UNIT_CONVERTOR_PENDING = "SET_UNIT_CONVERTOR_PENDING";
export const SET_UNIT_CONVERTOR_DATA = "SET_UNIT_CONVERTOR_DATA";
export const SET_UNIT_CURRENTFIELD = "SET_UNIT_CURRENTFIELD";
export const SET_UNIT_CONVERSION_RESPONSE = "SET_UNIT_CONVERSION_RESPONSE";
export const SET_UPDATE_RPM_PENDING = "SET_UPDATE_RPM_PENDING";
export const SET_UPDATE_RPM_VALUE = "SET_UPDATE_RPM_VALUE";
export const SET_IS_HYDROLUBRIC = "SET_IS_HYDROLUBRIC";

export const LIQ_CAPACITY = [
  {
    label: "m3/h",
    value: "m3/h",
    index: 0,
  },
    {
      label: "m3/s",
      value: "m3/s",
      index: 1,
    },
    {
      label: "l/min",
      value: "l/min",
      index: 2,
    },
    {
        label: "l/s",
        value: "l/s",
        index: 3,
    },
    {
        label: "UKgal/min",
        value: "UKgal/min",
        index: 4,
    },
    {
        label: "USgal/min",
        value: "USgal/min",
        index: 5,
    },
  ];

  export const DIFF_PRESSURE = [
    {
      label: "bar",
      value: "bar",
      index: 0,
    },
    {
      label: "Pa(N/m2)",
      value: "Pa",
      index: 1,
    },
    {
      label: "PSI",
      value: "PSI",
      index: 2,
    },
    {
        label: "mmHg",
        value: "mmHg",
        index: 3,
    },
    {
        label: "mWk",
        value: "mWk",
        index: 4,
    },
  ];

  export const TEMP_UNITS = [
    {
      label: "°C",
      value: "°C",
      index: 0,
    },
    {
      label: "°K",
      value: "°K",
      index: 1,
    },
    {
      label: "°F",
      value: "°F",
      index: 2,
    },
  ];

  export const LIQ_DENSITY = [
    {
      label: "kg/m3",
      value: "kg/m3",
      index: 0,
    },
    {
      label: "kg/l",
      value: "kg/l",
      index: 1,
    },
    {
      label: "lb/ft3",
      value: "lb/ft3",
      index: 2,
    },
    {
        label: "lb/in3",
        value: "lb/in3",
        index: 3,
    },
    {
        label: "Baume",
        value: "Baume",
        index: 4,
    },
  ];

  export const LIQ_VISCOSITY_METRIC = [
    {
      label: "mPas",
      value: "mPas",
      index: 0,
    },
    {
      label: "m2/s",
      value: "m2/s",
      index: 1,
  },
    {
      label: "cSt",
      value: "cSt",
      index: 2,
    },
    {
        label: "Saybolt",
        value: "Saybolt",
        index: 3,
    },
    {
        label: "Redwood",
        value: "Redwood",
        index: 4,
    },
    {
        label: "°Engler",
        value: "°Engler",
        index: 5,
    },    
  ];

  export const LIQ_VISCOSITY_US = [
    {
      label: "Cps",
      value: "Cps",
      index: 0,
    },
    {
      label: "m2/s",
      value: "m2/s",
      index: 1,
  },
    {
      label: "cSt",
      value: "cSt",
      index: 2,
    },
    {
        label: "Saybolt",
        value: "Saybolt",
        index: 3,
    },
    {
        label: "Redwood",
        value: "Redwood",
        index: 4,
    },
    {
        label: "°Engler",
        value: "°Engler",
        index: 5,
    },
  ];

  export const MAX_NPSHR = [
    {
      label: "m",
      value: "m",
      index: 0,
    },
    {
      label: "PSIa",
      value: "PSIa",
      index: 1,
    },
];

export const PERIPH_VELOCITY = [
    {
      label: "m/s",
      value: "m/s",
      index: 0,
    },
    {
      label: "ft/s",
      value: "ft/s",
      index: 1,
    },
];

export const PARTICLE_SIZE = [
    {
      label: "m",
      value: "m",
      index: 0,
    },
    {
      label: "mm",
      value: "mm",
      index: 1,
    },
    {
      label: "ft",
      value: "ft",
      index: 2,
    },
    {
        label: "in",
        value: "in",
        index: 3,
    },
    {
        label: "μ in",
        value: "μ in",
        index: 4,
    },
  ];